"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DictionaryEnum;
(function (DictionaryEnum) {
    DictionaryEnum["MWLEARNERS"] = "MWLearners";
    DictionaryEnum["MWELEMENTARY"] = "MWElementary";
    DictionaryEnum["MWINTERMEDIATE"] = "MWIntermediate";
    DictionaryEnum["MWSCHOOL"] = "MWSchool";
    DictionaryEnum["OXFORDELEMENTARYES"] = "OxfordElementaryEs";
})(DictionaryEnum || (DictionaryEnum = {}));
exports.default = DictionaryEnum;
